export default "__VITE_ASSET__OATKbRHeAt5edByUXUCi7A__"